
import React, { useState, useEffect, useRef } from "react";
// import "./invoice.css";
import logo from "../../../Assets/jklogo.png";
import logo1 from "../../../Assets/jk.png"
import Sign from "../../../Assets/DirectorSign.png";
import Sign1 from "../../../Assets/DirectorSign1.png";
import Santlogo from "../../../Assets/SantGollogo.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import QRCode from "qrcode";
import PdfPreview from "../../../Common/PDFPreview";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";
import PrintButton from "../../../Common/Buttons/PrintPDF";
import HeaderJK from "../../../Assets/HeaderJK.png";
import FooterJK from "../../../Assets/FooterJK.png";
import FooterJK1 from "../../../Assets/FooterJK1.png";
import "../../../Common/Fonts/Signika-Bold-normal";
import "../../../Common/Fonts/Signika-Regular-normal";
import "../../../Common/Fonts/Signika-Medium-normal";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";


const API_URL = process.env.REACT_APP_API;

const PattiReport = ({ Doc_No, disabledFeild }) => {
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const [invoiceData, setInvoiceData] = useState([]);
    const [pdfPreview, setPdfPreview] = useState(null);
    const TCSApplicable = sessionStorage.getItem("TCSApplicable");
    const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
    const newCompanyName = sessionStorage.getItem("newCompanyName")
    const oldFormerlyName = sessionStorage.getItem("oldFormerlyName")


    const fetchData = async () => {
        try {
            const response = await fetch(
                `${API_URL}/generating_PattiPrint_report?Company_Code=${companyCode}&Doc_No=${Doc_No}&Year_Code=${Year_Code}`
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();

            setInvoiceData(data.all_data);
            generatePdf(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const generatePdf = async (data) => {

        const pdf = new jsPDF({ orientation: "portrait" });
        const allData = data.all_data?.[0] || {};
        const advances = data?.all_advances || [];
        const Awakdetails = data?.all_AwakDetail || [];

        const docDate = new Date(allData.doc_date);
        const cnameUpdatedDate = new Date(CompanyNameUpdatedDate);

        const displayCompanyName =
            docDate < cnameUpdatedDate
                ? newCompanyName
                : allData.Company_Name_E;


        // const logoToUse = docDate < cnameUpdatedDate ? Santlogo : Santlogo;
        // const SignToUse = docDate < cnameUpdatedDate ? Sign1 : Sign;
        // const foormerlyName = docDate < cnameUpdatedDate ? oldFormerlyName : allData.AL1;

        const logoToUse = companyCode === "22" ? logo1 : Santlogo;
        const SignToUse = docDate < cnameUpdatedDate ? Sign1 : Sign;
        const foormerlyName = docDate < cnameUpdatedDate ? oldFormerlyName : allData.AL1;

        pdf.setFont("Signika-Regular");
        pdf.setFontSize(8);

        const logoImg = new Image();
        const signImg = new Image();
        // const headerImg = new Image();
        const footerImg = new Image();
        const footerImg1 = new Image();
        logoImg.src = Santlogo;
        // signImg.src = SignToUse;
        // headerImg.src = HeaderJK;
        // footerImg.src = FooterJK;
        // footerImg1.src = FooterJK1

        const qrCodeData = `
    GSTN of Supplier : ${allData.companyGSTNo || ""}
    GSTIN of Buyer : ${allData.billtogstno || ""}
    Document No. : ${allData.doc_no || ""}
    Document Type : Tax Invoice
    Date : ${allData.doc_date || ""}
    HSN : ${allData.HSN || ""}
    IRN : ${allData.einvoiceno || ""}
    `;
        const qrCodeDataUrl = await QRCode.toDataURL(qrCodeData.trim());

        logoImg.src = logoToUse;
        logoImg.onload = () => {

            let startY = 18;
            // const lineHeight = 4;
            const maxWidth = 120;

            const shouldUseImage = companyCode === "22";

            if (shouldUseImage) {
                // New layout for company 22: logo + company name + address lines
                pdf.addImage(logoImg, "PNG", 10, 9, 30, 30);
                pdf.setFont("Signika-Bold");
                pdf.setFontSize(14);
                pdf.text(displayCompanyName, 45, 14);
                pdf.setFont("Signika-Regular");
                pdf.setFontSize(9);
                pdf.text(`${foormerlyName || ""}`, 45, 18);
                pdf.text(`${allData.AL2 || ""}`, 45, 22);
                pdf.text(`${allData.AL3 || ""}`, 45, 26);
                pdf.text(`${allData.AL4 || ""}`, 45, 30);
                pdf.text(`${allData.Other || ""}`, 45, 34);
                pdf.text(`${allData.BillFooter || ""}`, 45, 38);
            } else {

                // Old layout: logo + company name + address lines
                pdf.addImage(logoImg, "PNG", 12, 2, 25, 25);
                pdf.setFont("Signika-Bold");
                // pdf.setFontSize(14);
                // // pdf.text(displayCompanyName, 45, 14);
                // pdf.setFont("Signika-Regular");
                // pdf.setFontSize(9);
                // pdf.text(`${foormerlyName}`, 45, 18);
                // pdf.text(`${allData.AL2}`, 45, 22);
                // pdf.text(`${allData.AL3}`, 45, 26);
                // pdf.text(`${allData.AL4}`, 45, 30);
                // pdf.text(`${allData.Other}`, 45, 34);
                // pdf.text(`${allData.BillFooter}`, 45, 38);
                pdf.text("By Laws No 18 & 52, Schedule No 18 Bill", 105, 12, { align: "center" });
                // ======= CUSTOM HEADER WITHOUT IMAGE =======
                pdf.setFont("Signika-Medium");
                pdf.setFontSize(16);
                pdf.setTextColor(0, 0, 0);


                // Center the text header
                pdf.text("Sangli Krushi Utappan Bazar Samiti , Sangli", 105, 18, { align: "center" });

            }
            // pdf.addImage(qrCodeDataUrl, "PNG", 170, 9, 30, 30);

            // Optional: small subtitle
            pdf.setFont("Signika-Regular");
            pdf.setFontSize(10);

            const drawPageHeader = () => {
                // ======= LOGO =======
                if (logoImg) {
                    pdf.addImage(logoImg, "PNG", 12, 8, 22, 22); // x,y,w,h
                    pdf.setFont("Signika-Bold");
                }

                // ======= TOP TITLE =======
                pdf.setFont("Signika-Regular");
                pdf.setFontSize(10);
                pdf.text(
                    "By Laws No 18 & 52, Schedule No 18 Bill",
                    105,
                    12,
                    { align: "center" }
                );

                // ======= MAIN HEADING =======
                pdf.setFont("Signika-Medium");
                pdf.setFontSize(16);
                pdf.setTextColor(0, 0, 0);

                pdf.text(
                    "Sangli Krushi Utappan Bazar Samiti , Sangli",
                    105,
                    18,
                    { align: "center" }
                );

                // ======= SUBTITLE =======
                pdf.setFont("Signika-Regular");
                pdf.setFontSize(10);
                // pdf.text(
                //     "Government Licensed Agricultural Market Committee",
                //     105,
                //     24,
                //     { align: "center" }
                // );

                // Reset text color for table
                pdf.setTextColor(0, 0, 0);

                // Set starting Y below header
                // y = 45;
                y = companyCode === "22" ? 45 : 34;
            };



            const headerLineY1 = companyCode === "22" ? 44 : 27;
            const pattiTitleY = companyCode === "22" ? 49 : 33;
            const headerLineY2 = companyCode === "22" ? 52 : 37;

            pdf.setFontSize(10);
            pdf.setFont("Signika-Bold");
            pdf.setDrawColor(80, 80, 80);
            pdf.setLineWidth(0.3);
            pdf.line(10, headerLineY1, 200, headerLineY1);
            pdf.setTextColor(41, 122, 14);
            pdf.text("SHETKARI PATTI", 95, pattiTitleY);
            pdf.setFont("Signika-Medium");
            pdf.setTextColor(0, 0, 0);
            pdf.text(`Patti No: ${allData.Doc_No}`, 12, pattiTitleY);
            pdf.setFont("Signika-Medium");
            pdf.setTextColor(0, 0, 0);
            pdf.text(`Patti Date: ${allData.Doc_Date}`, 165, pattiTitleY);
            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, headerLineY2, 200, headerLineY2);
            pdf.setTextColor(0, 0, 0);

            const drawInvoiceHeader = () => {

                const pageWidth = pdf.internal.pageSize.getWidth();

                pdf.setFontSize(10);
                pdf.setFont("Signika-Bold");

                pdf.setDrawColor(80, 80, 80);
                pdf.setLineWidth(0.3);

                // Top line
                pdf.line(10, 31, pageWidth - 10, 31);

                // Title
                pdf.setTextColor(41, 122, 14);
                pdf.text("SHETKARI PATTI", pageWidth / 2 - 10, 37);

                // Bill details
                pdf.setFont("Signika-Medium");
                pdf.setTextColor(0, 0, 0);

                pdf.text(`Patti No: ${allData.Doc_No}`, 12, 37);
                pdf.text(`Patti Date: ${allData.Doc_Date}`, pageWidth - 45, 37);

                // Bottom line
                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(10, 40, pageWidth - 10, 40);

                return 30;
            };


            let y = companyCode === "22" ? 40 : 25;
            pdf.setFontSize(9);

            const fieldPairs = [
                [
                    `Company Name. :${allData.Company_Name_E}`,
                    ``,
                    ``,
                ],
                [
                    `ADDRESS : ${allData.Address_E}`,
                    ``,
                    `PHONE NO : (0233)2670614,${allData.PHONE}`,
                ],
                [
                    ``,
                    ``,
                    ``,
                ],
                [
                    ``,
                    "",
                    ``,
                ],
                [
                    ``,
                    "",
                ],
                ["", "", "", ""],
            ];

            fieldPairs.forEach(([left1, left2, rightLabel, rightValue]) => {
                const leftX = 12;
                const middleX = 60;
                const rightX = 110;
                const wrapWidth = 85;
                const lineHeight = 4;

                const [rawLeftLabel, ...rawLeftValParts] = (left1 ?? "").split(":");
                const leftLabel = rawLeftLabel?.trim() ? `${rawLeftLabel.trim()}` : "";
                const leftValue = rawLeftValParts.join("").trim();
                const leftValueLines = pdf.splitTextToSize(leftValue, wrapWidth - pdf.getTextWidth(leftLabel));

                const left2Lines = pdf.splitTextToSize(left2 ?? "", wrapWidth);

                const rightLabelText = rightLabel?.trim() ? `${rightLabel.trim()}` : "";
                const rightValueText = rightValue?.toString().trim() ?? "";
                const rightValueLines = pdf.splitTextToSize(rightValueText, wrapWidth - pdf.getTextWidth(rightLabelText));

                const maxLines = Math.max(leftValueLines.length, left2Lines.length, rightValueLines.length);

                for (let i = 0; i < maxLines; i++) {
                    const yOffset = y + i * lineHeight + 17;

                    if (i === 0 && leftLabel) {
                        pdf.setFont("Signika-Medium");
                        pdf.text(leftLabel, leftX, yOffset);
                        pdf.setFont("Signika-Regular");
                        pdf.text(leftValueLines[i] ?? "", leftX + pdf.getTextWidth(leftLabel) + 1, yOffset);
                    } else if (leftValueLines[i]) {
                        pdf.setFont("Signika-Regular");
                        pdf.text(leftValueLines[i], leftX, yOffset);
                    }


                    if (left2Lines[i]) {
                        pdf.setFont("Signika-Regular");
                        pdf.text(left2Lines[i], middleX, yOffset);
                    }

                    if (i === 0 && rightLabelText) {
                        pdf.setFont("Signika-Medium");
                        pdf.text(rightLabelText, rightX, yOffset);
                        pdf.setFont("Signika-Regular");
                        pdf.text(rightValueLines[i] ?? "", rightX + pdf.getTextWidth(rightLabelText) + 1, yOffset);
                    } else if (rightValueLines[i]) {
                        pdf.setFont("Signika-Regular");
                        pdf.text(rightValueLines[i], rightX, yOffset);
                    }
                }

                y += maxLines * lineHeight;
            });

            const drawFieldPairs = () => {

                const leftX = 12;
                const middleX = 60;
                const rightX = 110;
                const wrapWidth = 85;
                const lineHeight = 4;

                const fieldPairs = [
                    [
                        `Company Name. :${allData.Company_Name_E}`,
                        ``,
                        `PAN NO. : ${allData.Pan_No}`,
                    ],
                    [
                        `ADDRESS : ${allData.Address_E}`,
                        ``,
                        `PHONE NO : (0233)2670614,${allData.PHONE}`,
                    ],
                    [
                        ``,
                        ``,
                        ``,
                    ],
                    [
                        ``,
                        "",
                        ``,
                    ],
                    [
                        ``,
                        "",
                    ],
                    ["", "", "", ""],
                ];

                fieldPairs.forEach(([left1, left2, rightLabel, rightValue]) => {

                    const [rawLeftLabel, ...rawLeftValParts] =
                        (left1 ?? "").split(":");

                    const leftLabel =
                        rawLeftLabel?.trim() ? `${rawLeftLabel.trim()}` : "";

                    const leftValue = rawLeftValParts.join("").trim();

                    const leftValueLines = pdf.splitTextToSize(
                        leftValue,
                        wrapWidth - pdf.getTextWidth(leftLabel)
                    );

                    const left2Lines = pdf.splitTextToSize(left2 ?? "", wrapWidth);

                    const rightLabelText =
                        rightLabel?.trim() ? `${rightLabel.trim()}` : "";

                    const rightValueText = rightValue?.toString().trim() ?? "";

                    const rightValueLines = pdf.splitTextToSize(
                        rightValueText,
                        wrapWidth - pdf.getTextWidth(rightLabelText)
                    );

                    const maxLines = Math.max(
                        leftValueLines.length,
                        left2Lines.length,
                        rightValueLines.length
                    );

                    for (let i = 0; i < maxLines; i++) {

                        const yOffset = y + i * lineHeight + 17;

                        // LEFT label + value
                        if (i === 0 && leftLabel) {
                            pdf.setFont("Signika-Medium");
                            pdf.text(leftLabel, leftX, yOffset);

                            pdf.setFont("Signika-Regular");
                            pdf.text(
                                leftValueLines[i] ?? "",
                                leftX + pdf.getTextWidth(leftLabel) + 1,
                                yOffset
                            );
                        } else if (leftValueLines[i]) {
                            pdf.setFont("Signika-Regular");
                            pdf.text(leftValueLines[i], leftX, yOffset);
                        }

                        // MIDDLE text
                        if (left2Lines[i]) {
                            pdf.setFont("Signika-Regular");
                            pdf.text(left2Lines[i], middleX, yOffset);
                        }

                        // RIGHT label + value
                        if (i === 0 && rightLabelText) {
                            pdf.setFont("Signika-Medium");
                            pdf.text(rightLabelText, rightX, yOffset);

                            pdf.setFont("Signika-Regular");
                            pdf.text(
                                rightValueLines[i] ?? "",
                                rightX + pdf.getTextWidth(rightLabelText) + 1,
                                yOffset
                            );
                        } else if (rightValueLines[i]) {
                            pdf.setFont("Signika-Regular");
                            pdf.text(rightValueLines[i], rightX, yOffset);
                        }
                    }

                    y += maxLines * lineHeight;
                });

                // return next y after block
                return y;
            };


            const verticalX = 105;
            const topOfFieldPairs = 59;
            const bottomOfFieldPairs = y + 12;

            pdf.setDrawColor(80, 80, 80);
            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            function drawBuyerSection(pdf, billToLines, y) {
                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(10, y - 1, 200, y - 1);

                const addressStartY = y - 5;

                const endYBill = addressBlock(
                    12,
                    addressStartY,
                    "",
                    billToLines
                );

                return endYBill + 4;
            }


            const addressBlock = (x, yStart, title, lines) => {
                let y = yStart;
                const lineHeight = 4; // space between lines

                // Draw title
                pdf.setFont("Signika-Medium");
                pdf.setTextColor(0, 0, 0);
                pdf.text(title, x, y + 10);
                y += lineHeight + 5;

                // Compute maximum label width
                const labelWidth = Math.max(
                    ...lines.map(line => {
                        const [label] = line.split(":");
                        return pdf.getTextWidth(label.trim());
                    })
                );

                // Draw lines
                lines.forEach((line) => {
                    const [label, ...valueParts] = line.split(":");
                    const value = valueParts.join(":").trim();

                    // Draw label
                    pdf.setFont("Signika-Bold");
                    pdf.setTextColor(41, 122, 14); // green color for labels
                    pdf.text(label.trim() + ":", x, y);

                    // Draw value starting at fixed position
                    pdf.setFont("Signika-Regular");
                    pdf.setTextColor(0, 0, 0);
                    pdf.text(value, x + labelWidth + 2, y); // 2 units padding

                    y += lineHeight;
                });

                return y; // return updated y
            };



            const isRegular =
                allData.carporateSaleDoc !== 0 &&
                allData.carporateSaleDoc !== "" &&
                allData.selling_type === "P" &&
                allData.Delivery_type === "C";

            const fssaiNo = isRegular
                ? allData.FSSAI_BillTo
                : allData.carporateBillToFSSAI || allData.FSSAI_BillTo;

            const tanNo = isRegular
                ? allData.BillToTanNo
                : allData.Carporate_Tanno || allData.BillToTanNo;

            const billToLines = [
                `Farmer Name: ${allData.FarmerName}`,
                `Party Name: ${isRegular
                    ? allData.CustomerName
                    : allData.CustomerName || allData.CustomerName}`,
                `Awak Date: ${allData.AwakDate}`,
                `TolaiDar: ${allData.tolaidar}`,
                `RTGS Party Name: ${allData.RTGSPartyName || ""}`,
                fssaiNo ? `FSSAI: ${fssaiNo}` : null,
                tanNo ? `TAN: ${tanNo}` : null,
            ].filter(Boolean);

            const fssaiShipTo = allData.FSSAI_ShipTo;
            const tanShipTo = allData.ShipToTanNo;
            const saudadate = Awakdetails[0]?.SaudaDate;
            const shipToLines = [
                // allData.shiptoaddress,
                `Farmer Code: ${allData.Ac_Code}`,
                `Farmer Mobile No: ${allData.Mobile_No || ""}`,
                `Sauda Date: ${saudadate}`,

            ].filter(Boolean); // removes null/undefined/empty

            const pageHeight = pdf.internal.pageSize.getHeight();
            const bottomMargin = 40;   // space for totals + footer


            // Get unique Awak Nos from data
            const uniqueAwakNos = [
                ...new Set(
                    (data.all_data || [])
                        .map(item => item.AwakNo)
                        .filter(Boolean)
                )
            ];

            // Convert to comma-separated string
            const awakNoText = uniqueAwakNos.join(", ");


            pdf.text(`Awak No: ${awakNoText}`, 12, y + 33);
            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, y - 1, 200, y - 1);

            const addressStartY = y - 5;
            // setTextColor(0, 0, 0)
            const endYBill = addressBlock(12, addressStartY, "", billToLines);
            const endYShip = addressBlock(110, addressStartY, "", shipToLines);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(105, addressStartY + 6, 105, Math.max(endYBill, endYShip) + 7);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(
                10,
                Math.max(endYBill, endYShip) + 10,
                200,
                Math.max(endYBill, endYShip) + 10
            );
            y = Math.max(endYBill, endYShip) + 8;

            const verticalStartAfterGap = addressStartY + 15;
            const verticalEnd = Math.max(endYBill, endYShip);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(105, verticalStartAfterGap + 50, 105, verticalEnd + 8);





            // const drawTableHeader = () => {
            //     pdf.setLineWidth(0.3);
            //     pdf.setDrawColor(80, 80, 80);
            //     pdf.line(
            //         10,
            //         Math.max(endYBill, endYShip) + 5,
            //         200,
            //         Math.max(endYBill, endYShip) + 5
            //     );
            //     pdf.setFont("Signika-Medium");
            //     pdf.setTextColor(41, 122, 14);

            //     pdf.text("Item Name", 13, y);
            //     pdf.text("Katta Patti", 50, y);
            //     pdf.text("Quantity", 95, y, { align: "right" });
            //     pdf.text("Net Weight", 135, y, { align: "right" });
            //     pdf.text("Rate", 165, y, { align: "right" });
            //     pdf.text("Value", 197, y, { align: "right" });

            //     pdf.setTextColor(0, 0, 0);

            //     pdf.setDrawColor(80, 80, 80);
            //     pdf.line(10, y - 4, 200, y - 4);

            //     y += 6;
            // };

            const drawTableHeader = () => {

                const pageNo = pdf.internal.getCurrentPageInfo().pageNumber;

                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);

                //  Top line position
                const topLineY =
                    pageNo === 1
                        ? Math.max(endYBill, endYShip) + 5   // first page
                        : y - 3;                             // next pages

                pdf.line(10, topLineY, 200, topLineY);

                //  Adjust y for heading text
                if (pageNo === 1) {
                    y = topLineY + 8;
                } else {
                    y += 2;
                }

                pdf.setFont("Signika-Medium");
                pdf.setTextColor(41, 122, 14);

                pdf.text("Item Name", 13, y);
                pdf.text("Katta Patti", 50, y);
                pdf.text("Quantity", 95, y, { align: "right" });
                pdf.text("Net Weight", 135, y, { align: "right" });
                pdf.text("Rate", 165, y, { align: "right" });
                pdf.text("Value", 197, y, { align: "right" });

                pdf.setTextColor(0, 0, 0);

                //  Bottom line under heading
                pdf.line(10, y + 2, 200, y + 2);

                y += 6;
            };

            const HEADER_CONTENT_GAP = 50;


            const addNewPage = () => {

                pdf.addPage();

                // draw top invoice header
                y = drawInvoiceHeader();
                drawFieldPairs();
                y = drawBuyerSection(pdf, billToLines, y);

                // optional page sub-header (address / party etc.)
                drawPageHeader();

                // add spacing gap before table header
                y += HEADER_CONTENT_GAP;

                // finally draw table header
                drawTableHeader();
            };



            // pdf.setLineWidth(0.3);
            // pdf.setDrawColor(80, 80, 80);
            // pdf.line(10, y + 5, 200, y + 5);



            const amountX = 187;


            y += 6; // space below header
            drawTableHeader();

            const ROW_HEIGHT = 4; // base row height
            const ROW_SPACING = 2; // space between rows
            const poweredByY = 292; // fixed row height like first page
            const ROWS_PER_PAGE = 20;


            let rowsOnPage = 0;

            const items = data.all_data || [];
            (items || []).forEach((item) => {
                pdf.setFont("Signika-Medium");
                pdf.setTextColor(0, 0, 0);

                const farmerText = item.System_Name_E?.trim() || "Sugar";
                const wrappedFarmer = pdf.splitTextToSize(farmerText, 45);
                // const wrappedItem = pdf.splitTextToSize(String(item.System_Name_E ?? ""), 50);

                const rowHeight = ROW_HEIGHT * Math.max(wrappedFarmer.length);

                // Page break check: either max rows reached OR space exceeded before footer
                if (rowsOnPage >= ROWS_PER_PAGE || y + rowHeight + ROW_SPACING > poweredByY - 30) {
                    addNewPage(); // resets y and draws header
                    rowsOnPage = 0; // reset counter for new page
                }

                // Draw row (use fixed row height for spacing)
                pdf.setFont("Signika-Medium");
                pdf.text(String(item.Awak_No ?? ""), 17, y, { align: "right" });
                pdf.text(wrappedFarmer, 13, y);

                pdf.setFont("Signika-Regular");
                pdf.text(String(item.Kattapatti), 64, y, { align: "right" });

                const value = parseFloat(item.PattiDetailnetamt || 0);
                const rate = parseFloat(item.Value || 0);
                const netweight = parseFloat(item.DetailNetWt || 0);

                const formattedQty = Number(item.Qty || 0)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2 });
                const formattedRate = Number(rate)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2 });
                const formattedValue = Number(value)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2 });
                const formattednetweight = Number(netweight)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2 });

                pdf.text(formattednetweight, 135, y, { align: "right" });
                pdf.text(`${formattedQty}`, 95, y, { align: "right" });
                pdf.text(formattedRate, 165, y, { align: "right" });
                pdf.text(formattedValue, 197, y, { align: "right" });

                y += rowHeight + ROW_SPACING; // move to next row
                rowsOnPage++;
            });



            const lineHeight = 5;
            pdf.setFont("Signika-Bold");
            pdf.setTextColor(0, 0, 0);

            pdf.text("Total", 12, y);

            // Totals from your data object (alldata)
            const totalQty = Number(allData.netQty || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });
            const totalWeight = Number(allData.netwt || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });
            const totalValue = Number(allData.netAmt || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });

            pdf.text(totalWeight, 135, y, { align: "right" });       // Net Weight
            pdf.text(`${totalQty}`, 95, y, { align: "right" }); // Quantity
            pdf.text(totalValue, 197, y, { align: "right" }); // Value

            const ensureSpace = (neededHeight) => {
                const pageHeight = pdf.internal.pageSize.getHeight();
                const bottomLimit = pageHeight - 30;   // leave space for footer

                if (y + neededHeight > bottomLimit) {
                    pdf.addPage();
                    y = 40;
                    y = drawInvoiceHeader();
                    drawFieldPairs();
                    y = drawBuyerSection(pdf, billToLines, y);

                    // optional page sub-header (address / party etc.)
                    drawPageHeader();

                    // add spacing gap before table header
                    y += HEADER_CONTENT_GAP;

                }
            };


            // Draw line above totals

            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(10, y + 4, 200, y + 4);
            pdf.line(10, y - 4, 200, y - 4);

            // Optional: line under totals
            pdf.line(10, y + 2, 200, y + 2);

            y += lineHeight;
            ensureSpace(60);

            const containerAmt = Number(allData.Container || 0);
            const netAmt = Number(allData.netAmt || 0);

            pdf.setFont("Signika-Regular");
            pdf.text("Container:", 130, y + 6, { align: "left" });
            pdf.text(
                formatReadableAmount(containerAmt),
                197,
                y + 6,
                { align: "right" }
            );


            pdf.setFont("Signika-Bold");
            const subTotalWithContainer = netAmt + containerAmt || 0;

            pdf.text("Total:", 130, y + 11);
            pdf.text(
                formatReadableAmount(subTotalWithContainer),
                197,
                y + 11,
                { align: "right" }
            );




            y += 8; // move cursor below totals if needed


            // pdf.setFont("Signika-Bold");
            // pdf.setFontSize(10);
            // pdf.text("Bank Details:", 12, y - 1, { align: "left" });
            // pdf.setFont("Signika-Regular");
            // pdf.setFontSize(8);
            // pdf.text(`Bank Name: ${allData.Bank_Name}`, 12, y + 3, { align: "left" });
            // pdf.text(`Bank Ac/No: ${allData.Bank_Ac_No}`, 12, y + 7, { align: "left" });
            // pdf.text(`IFSC: ${allData.IFSC}`, 12, y + 12, { align: "left" });



            pdf.setFont("Signika-Bold");
            pdf.setFontSize(10);
            pdf.text("Bank Details:", 12, y, { align: "left" });

            pdf.setFont("Signika-Regular");
            pdf.setFontSize(8);

            const labels = ["Bank Name:", "Bank Ac/No:", "IFSC:"];
            const values = [
                allData.Bank_Name,
                allData.Bank_Ac_No,
                allData.IFSC
            ];

            const labelX = 12;

            // Always calculate widths from valid strings
            const maxLabelWidth = Math.max(
                ...labels.map(l => pdf.getTextWidth(String(l)))
            );

            const valueX = labelX + maxLabelWidth + 3;
            let currentY = Number(y || 0) + 4;

            labels.forEach((label, i) => {
                const value = String(values[i] ?? ""); // 

                // Wrap long values
                const wrappedValue = pdf.splitTextToSize(value, 80);

                pdf.setFont("Signika-Regular");
                pdf.text(label, labelX, currentY);

                pdf.text(wrappedValue, valueX, currentY);

                currentY += wrappedValue.length * lineHeight;
            });






            let fssai = String(allData.MillFSSAI_No ?? "").trim();
            if (fssai !== "") {
                // Manually insert breakable characters every 15 chars if needed
                if (fssai.length > 25 && !fssai.includes(" ")) {
                    fssai = fssai.match(/.{1,20}/g).join(" ");
                }

                const wrappedFSSAI = pdf.splitTextToSize(fssai, 100);
                pdf.text("Mill FSSAI:", 12, currentY);
                pdf.text(wrappedFSSAI, 28, currentY);
            }



            y += 10;

            // 1. Parse out your rates / amounts
            const igstRate = parseFloat(allData.IGSTRate) || 0;
            const igstAmt = parseFloat(allData.IGSTAmount) || 0;

            const cgstRate = parseFloat(allData.CGSTRate) || 0;
            const cgstAmt = parseFloat(allData.CGSTAmount) || 0;

            const sgstRate = parseFloat(allData.SGSTRate) || 0;
            const sgstAmt = parseFloat(allData.SGSTAmount) || 0;

            const taxRows = [];

            if (igstRate > 0) {
                // only IGST
                taxRows.push(["IGST", igstRate, igstAmt]);
            } else {
                taxRows.push(
                    //   ["CGST", cgstRate, cgstAmt],
                    //   ["SGST", sgstRate, sgstAmt]

                );
            }

            const summaryFields = [
                ...(allData.carporateSaleDoc === 0 ||
                    allData.carporateSaleDoc === "" ||
                    allData.carporateSaleDoc === null
                    ? [["Freight", allData.LESS_FRT_RATE, allData.freight]]
                    : []),

                // ["Taxable Amount", "", allData.SubTotal],
                ...taxRows,
                ["Hamali", "", allData.Hamaliamt],
                ["Tolai", "", allData.Tolai],
                ["Advance", "", allData.Advances],

            ];


            let headingAdded = false; // ✅ to ensure heading appears only once

            summaryFields.forEach(([label, rate, amount]) => {
                // Add heading before "Taxable Amount" group
                if (!headingAdded && ["Taxable Amount", "Leavy", "Commission", "Market Cess", "Dekrekh"].includes(label)) {
                    pdf.setFont("Signika-Medium");
                    pdf.setTextColor(41, 122, 14);
                    pdf.text("Other Expenses", 130, y);
                    pdf.text("Amount", 197, y, { align: "right" });
                    y += 4; // space below heading
                    headingAdded = true;
                }

                // Draw each summary row
                pdf.setFont("Signika-Regular");
                pdf.setTextColor(0, 0, 0);

                pdf.text(`${label}:`, 130, y + 3);

                // Rate column (if exists)
                if (rate !== null && rate !== undefined && rate !== "") {
                    pdf.text(`${formatReadableAmount(rate)}%`, 165, y + 3, { align: "center" });
                }

                // Amount (formatted)
                const formattedAmount = formatReadableAmount(amount);
                pdf.text(formattedAmount, 197, y + 3, { align: "right" });

                y += 5;
            });

            const totalQtyNum = Number(allData.netQty || 0);
            const totalWeightNum = Number(allData.netwt || 0);
            const totalValueNum = Number(allData.netAmt || 0);

            const averageWeight =
                totalQtyNum > 0 ? totalWeightNum / totalQtyNum : 0;

            const averageRate =
                totalWeightNum > 0 ? (totalValueNum / totalWeightNum) * 100 : 0;

            const avgWeightFormatted = formatReadableAmount(averageWeight);
            const avgRateFormatted = formatReadableAmount(averageRate);




            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, y + 4, 200, y + 4);

            const totalAmount =
                Number(allData.Hamaliamt || 0) +
                Number(allData.Tolai || 0);
            // Number(allData.MarketCess || 0) +
            // Number(allData.DekhRekh || 0);

            const formattedTotal = formatReadableAmount(totalAmount);

            pdf.setFont("Signika-Bold");
            pdf.setTextColor(41, 122, 14);
            pdf.text("Total Expenses:", 150, y + 9);
            pdf.text(`₹ ${formattedTotal}`, amountX + 10, y + 9, { align: "right" });

            pdf.setFont("Signika-Regular");
            pdf.setTextColor(0, 0, 0);

            pdf.text("Average Weight:", 13, y + 9);
            pdf.text(avgWeightFormatted, 40, y + 9, { align: "left" });

            pdf.text("Average Rate:", 13, y + 13);
            pdf.text(avgRateFormatted, 40, y + 13, { align: "left" });

            // y += 5;
            pdf.setLineWidth(0.3);
            // pdf.line(10, y + 7, 200, y + 7);

            pdf.setFont("Signika-Bold");
            pdf.setTextColor(0, 0, 0);
            pdf.setFontSize(8);
            // pdf.text("Terms & Conditions:", 12, y + 12);
            // pdf.setFont("Signika-Regular");
            // const notes = [
            //     "- If there is no insurance of the goods, after dispatch from the destination,",
            //     "   we are not responsible for non delivery, damage or any kind of loss.",
            //     "- Buyer must inspect and confirm quality & quantity of the goods before dispatch from godown.",
            //     "   Once loaded and truck leaves godown, Said all responsibilities will be transfer to buyers account.",
            //     "- Please send the full amount in our account through RTGS before despatch the goods.",
            //     "   If the amount is not received in our account, Interest of 24% P.A. will be charged to the buyer.",
            //     `- Subject to ${allData.companyCity} jurisdiction.`
            // ];
            // notes.forEach((n, i) => pdf.text(n, 12, y + 13 + (i + 1) * 3));

            y += 25;
            const summaryY = poweredByY - 30;
            if (allData.SBNarration) {
                pdf.text(`${allData.SBNarration}`, 12, y + 12)
            }
            const signY = y - 10;
            pdf.setFont("Signika-Bold");
            pdf.setFontSize(9);
            pdf.setTextColor(0, 0, 0);

            const signWidth = 240;
            const signHeight = signWidth / 5;

            y -= 80;

            const billY = y + 68;      // Bill Amount Y
            const payableY = y + 75;   // Payable Y

            // Draw LINE ABOVE Bill Amount
            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, billY + 2, 200, billY + 2);

            const isMarketCessApplicable = allData.MarketCess === "Y";

            const dekhRekhAmt = isMarketCessApplicable
                ? Number(allData.DekhRekh || 0)
                : 0;

            const marketCessAmt = isMarketCessApplicable
                ? Number(allData.HeadMarketcess || 0)
                : 0;

            const baseBillAmount = Number(allData.Patti_Amount || 0)
                + Number(allData.Leavy || 0)
                + Number(allData.Commission || 0);

            const finalBillAmount = baseBillAmount + dekhRekhAmt + marketCessAmt;


            // pdf.addImage(signImg, "PNG", 157, y + 11, signWidth, signHeight);
            pdf.setFont("Signika-Medium");
            pdf.text("Patti Amount", 150, y + 75);

            // Value (right-aligned exactly like Amount column)
            pdf.text(
                Number(baseBillAmount || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
                197,
                y + 75,
                { align: "right" }
            );

            const totalInWords = ConvertNumberToWord(
                (baseBillAmount)
            );
            pdf.text(`Rs: ${totalInWords}.`, 12, y + 75);
            const Total = Number(baseBillAmount || 0).toLocaleString(
                "en-IN",
                {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }
            );

            pdf.line(10, payableY + 3, 200, payableY + 3);


            if (advances.length > 0) {
                let y = 25;
                const ROW_HEIGHT = 6;

                // ----------------------
                // Step 1: Prepare summary from all_data
                // ----------------------
                const itemSummary = {}; // { Item_Code: { itemName, totalQty, totalNetWt, totalNetAmt } }

                (data.all_data || []).forEach(row => {
                    const itemCode = row.Item_Code;
                    const itemName = String(row.System_Name_E || "").trim();
                    const qty = Number(row.Qty || 0);
                    const netWt = Number(row.DetailNetWt || 0);
                    const netAmt = Number(row.PattiDetailnetamt || 0);

                    if (!itemCode) return;

                    if (!itemSummary[itemCode]) {
                        itemSummary[itemCode] = {
                            itemName,
                            totalQty: 0,
                            totalNetWt: 0,
                            totalNetAmt: 0
                        };
                    }

                    itemSummary[itemCode].totalQty += qty;
                    itemSummary[itemCode].totalNetWt += netWt;
                    itemSummary[itemCode].totalNetAmt += netAmt;
                });

                // Step 2: Print Item Summary in PDF
                pdf.addPage();
                pdf.setFont("Signika-Bold");
                pdf.setFontSize(12);
                pdf.text("PATTI AWAK & ADVANCE DETAILS", 105, y, { align: "center" });
                pdf.setFont("Signika-Regular");
                const startX = 12;

                pdf.text(`FARMER NAME: ${allData.FarmerName}`, startX, y + 10);
                pdf.text(`PATTI NO: ${allData.Doc_No}`, startX, y + 16);

                y += 20;

                pdf.setDrawColor(80, 80, 80);
                pdf.setLineWidth(0.3);
                pdf.line(10, y, 200, y);
                y += 4;

                pdf.setFont("Signika-Bold");
                pdf.setFontSize(8);
                pdf.text("Item Name", 13, y);
                pdf.text("Qty", 80, y, { align: "right" });
                pdf.text("Net Weight", 130, y, { align: "right" });
                pdf.text("Value", 180, y, { align: "right" });
                y += 3;
                pdf.line(10, y, 200, y);
                y += 4;

                pdf.setFont("Signika-Regular");

                Object.values(itemSummary).forEach(row => {
                    // Calculate value = (totalNetAmt / totalNetWt) * 100
                    const value = row.totalNetWt ? (row.totalNetAmt / row.totalNetWt) * 100 : 0;
                    const roundedValue = value.toFixed(2);

                    // Page break if near bottom
                    if (y + ROW_HEIGHT > 280) {
                        pdf.addPage();
                        y = 25;
                    }

                    pdf.text(row.itemName || "", 13, y);
                    pdf.text(row.totalQty.toLocaleString("en-IN", { minimumFractionDigits: 2 }), 80, y, { align: "right" });
                    pdf.text(row.totalNetWt.toLocaleString("en-IN", { minimumFractionDigits: 2 }), 130, y, { align: "right" });
                    pdf.text(roundedValue.toLocaleString("en-IN", { minimumFractionDigits: 2 }), 180, y, { align: "right" });
                    y += ROW_HEIGHT;
                });

                // ----------------------
                // Step 3: Print Advance Details
                // ----------------------
                y += 10; // space after summary

                pdf.setFont("Signika-Bold");
                pdf.setFontSize(12);
                pdf.text("ADVANCE DETAILS", 105, y, { align: "center" });
                y += 8;

                pdf.setDrawColor(80, 80, 80);
                pdf.setLineWidth(0.3);
                pdf.line(10, y, 200, y);
                y += 4;

                pdf.setFont("Signika-Bold");
                pdf.setFontSize(8);
                pdf.text("Advance No", 13, y);
                pdf.text("Awak No", 50, y);
                pdf.text("Advance Date", 130, y);
                pdf.text("Amount", 190, y, { align: "right" });
                y += 3;
                pdf.line(10, y, 200, y);
                y += 4;

                pdf.setFont("Signika-Regular");
                let totalAdvance = 0;
                const awakTotals = {}; // { AwakNo: sum }

                advances.forEach((row) => {
                    if (y + ROW_HEIGHT > 280) {
                        pdf.addPage();
                        y = 25;
                    }

                    const dateText = row.AdvanceDate || "";

                    pdf.text(String(row.Advance_No || ""), 20, y);
                    pdf.text(String(row.AwakNo || ""), 50, y);
                    pdf.text(dateText, 130, y);
                    pdf.text(
                        Number(row.Amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
                        190,
                        y,
                        { align: "right" }
                    );

                    totalAdvance += Number(row.Amount || 0);
                    awakTotals[row.AwakNo] = (awakTotals[row.AwakNo] || 0) + Number(row.Amount || 0);

                    y += ROW_HEIGHT;
                });



                // Draw horizontal line above totals
                pdf.setFont("Signika-Bold");
                pdf.line(10, y, 200, y);
                y += 4;

                const AWAK_ROW_GAP = 4;

                // Grand Total Advance
                pdf.text("Total Advance:", 90, y);
                pdf.text(
                    totalAdvance.toLocaleString("en-IN", { minimumFractionDigits: 2 }),
                    190,
                    y,
                    { align: "right" }
                );

                y += 6;

                // Awak → Item → Total Qty
                // Awak → list of items (NO TOTAL)
                const awakItemSummary = {};

                (data.all_AwakDetail || []).forEach(row => {
                    const awakNo = row.Awakdocno;
                    const itemName = String(row.System_Name_E || "").trim();
                    const qty = Number(row.Awak_Qty || 0);

                    if (!awakNo || !itemName) return;

                    if (!awakItemSummary[awakNo]) {
                        awakItemSummary[awakNo] = [];
                    }

                    awakItemSummary[awakNo].push({
                        itemName,
                        qty
                    });
                });


                // Printing to PDF in a single line per Awak
                pdf.setFont("Signika-Bold");
                pdf.setFontSize(10);
                // pdf.text("Awak Details:", 12, y);
                // y += 5;

                // pdf.setFontSize(8);
                // Object.keys(awakItemSummary)
                //     .sort((a, b) => Number(a) - Number(b))
                //     .forEach(awakNo => {

                //         if (y > 280) {
                //             pdf.addPage();
                //             y = 25;
                //         }

                //         // Awak heading
                //         pdf.setFont("Signika-Bold");
                //         pdf.text(`Awak No ${awakNo}`, 12, y);
                //         y += 4;

                //         pdf.setFont("Signika-Regular");
                //         pdf.setFontSize(8);

                //         // Combine all items for this Awak into a single line
                //         const itemLine = Object.entries(awakItemSummary[awakNo])
                //             .map(([itemName, qty]) => `${itemName} : ${qty.toLocaleString("en-IN", {
                //                 minimumFractionDigits: 2,
                //                 maximumFractionDigits: 2
                //             })}`)
                //             .join(" , "); // comma separator

                //         if (y > 280) {
                //             pdf.addPage();
                //             y = 25;
                //         }

                //         pdf.text(itemLine, 18, y);
                //         y += 6; // gap after each Awak
                //     });

                pdf.setFont("Signika-Bold");
                pdf.setFontSize(10);
                pdf.text("Awak Details:", 12, y);
                y += 5;

                pdf.setFontSize(8);

                Object.keys(awakItemSummary)
                    .sort((a, b) => Number(a) - Number(b))
                    .forEach(awakNo => {

                        if (y > 280) {
                            pdf.addPage();
                            y = 25;
                        }

                        // Awak heading
                        pdf.setFont("Signika-Bold");
                        pdf.text(`Awak No ${awakNo}`, 12, y);
                        y += 4;

                        pdf.setFont("Signika-Regular");

                        // Single line, NO TOTALING
                        const itemLine = awakItemSummary[awakNo]
                            .map(item =>
                                `${item.itemName} : ${item.qty.toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}`
                            )
                            .join(" , ");

                        const wrappedLines = pdf.splitTextToSize(itemLine, 170); // 170 = usable width

                        pdf.text(wrappedLines, 18, y);

                        // move Y based on number of wrapped lines
                        y += wrappedLines.length * 4;
                        y += 6;
                    });

            }


            pdf.setFont("Signika-Medium");
            pdf.setFontSize(7);
            pdf.setTextColor(0, 0, 0);
            pdf.text("Powered by: Sugarian.app", 12, poweredByY);

            const pdfBlob = pdf.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfPreview(pdfUrl);
        };
    }

    return (
        <div id="pdf-content">
            {pdfPreview && (
                <PdfPreview
                    pdfData={pdfPreview}
                    apiData={invoiceData[0]}
                    label={"SaleBill"}
                />
            )}
            <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} label={"Patti Print"} />
        </div>
    );
};
export default PattiReport;